import styled from "styled-components"
import colors from "~constants/colors"

export const WebInviteContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 10px;
  padding: 0 4px;
`

export const WebInviteCheckbox = styled.input.attrs({ type: "checkbox" })`
  width: 16px;
  height: 16px;
  margin-right: 10px;
  cursor: pointer;
`

export const WebInviteLabel = styled.label`
  font-size: 14px;
  cursor: pointer;
  user-select: none;
  color: ${colors.gray4};
  letter-spacing: 0.76px;
  line-height: 100%;
`
